<template>
  <div class="flex min-h-screen items-center justify-center p-8">
    <div class="max-w-md text-center">
      <h1 class="mb-4 text-2xl font-semibold">Authentication Failed</h1>
      <p class="mb-6 opacity-80">
        We couldn't sign you in. This could be a temporary issue with the authentication service.
      </p>
      <div class="flex justify-center gap-4">
        <DButton @click="retry" label="Try Again" />
        <DButton @click="logout" label="Log Out" severity="secondary" />
      </div>
    </div>
  </div>
</template>

<script setup>
import { useUserStore } from '@/stores/userStore';
import { DButton } from '@disguise/cloud-ui';

const userStore = useUserStore();

const retry = () => {
  sessionStorage.removeItem('auth_attempts');
  userStore.loginWithProvider('oidc_auth0', '/callback');
};

const logout = () => {
  userStore.logoutUser();
};
</script>
